import {
	Box,
	TextField,
	InputAdornment,
	Grid,
	Button,
	Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import React from "react";
import { sizes } from "../setupUtils";
import TransferList from "./TransferList";
import BasicModal from "./BasicModal";
import { useDispatch, useSelector } from "react-redux";
import { getProductGroups, setPGState } from "./productGroupSetupSlice";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function SelectSKU() {
	const pgState = useSelector((store) => store.productGroupSetup);
	const { skus, selectedSKUs, countryID, searchedPGName, is_sku_refresh } = pgState;
	const dispatch = useDispatch();

   function setSearchedPGName(event) {
      const name = event.target.value;
      dispatch(setPGState("searchedPGName", name));
   }

	function searchSKUs() {
		dispatch(setPGState("is_sku_refresh", true));
		const productGroupName = searchedPGName;
		dispatch(getProductGroups({ countryID, productGroupName }));
	}

	return (
		<Box>
				{/* <Typography className="compHeading"
					sx={{ fontWeight: "bold", color: "blue.main" }}
					gutterBottom
				>
					Select SKU to add
				</Typography> */}
			    <CollapseSection title="Select SKU to add">
				<Box sx={{ mt: 2, border: 1, borderRadius: 1, p: 2, borderColor:"#c6c6c6", }}>
					
					<Box sx={{ p: 1}}>
						<Grid container columns={10} spacing={2} rowGap={2}>
							<Grid item sm={7.5} md={8.7} lg={9}>
								<TextField
									label="SKU"
									InputProps={{
										startAdornment: (
											<InputAdornment position="end">
												<EditIcon />
											</InputAdornment>
										),
									}}
									variant="standard"
									onChange={setSearchedPGName}
									value={searchedPGName}
								/>
							</Grid>

							<Grid item sm={.8}>
								<Button
									startIcon={<KeyboardArrowRightIcon />}
									sx={{
										bgcolor: "blue.main",
										color: "white.main",
										textTransform: "none",
										"&:hover": {
											bgcolor: "lightBlue.main",
										},
									}}
									onClick={searchSKUs}
								>
									<Typography
										sx={{ fontWeight: "bold", color: "white.main" }}
									>
										Go
									</Typography>
								</Button>
							</Grid>
						</Grid>
					</Box>

					<TransferList
						leftList={skus}
						rightList={selectedSKUs}
						leftState={"skus"}
						rightState={"selectedSKUs"}
					/>
				<BasicModal/>
				</Box>
				</CollapseSection>
		</Box>
	);
}
